import "./polyfill";
// 劫持XHR， 替换接口
import "./libs/hijackLayer";
import Vue from "vue";
import i18n from "./libs/i18n";
import store from "./libs/store/accountStore";
import services from "./libs/service";
import "./libs/commonComponents";

/**
 * framework 职责：
 * 注入 i18n, store
 * 注入 service： eventBus, moduleLoad, accountStore
 * 注册公共组件与样式
 */

window.useService = function (serviceName) {
  return services[serviceName];
};

window.eventBus = useService("EventBus");

function loadVModalManager() {
  const moduleLoadService = useService("ModuleLoadService");
  const asyncModule = import("@/utils/modalManager");
  moduleLoadService.load("modal", asyncModule);
  asyncModule.then(() => {
    window.eventBus.$emit("model-module:loaded");
  });
}

if (window.requestIdleCallback) {
  requestIdleCallback(loadVModalManager, {
    timeout: 2000,
  });
} else {
  loadVModalManager();
}

class WrapperVue extends Vue {
  constructor(options) {
    super({
      i18n,
      store,
      ...options,
    });
  }
}

export default function installFramework(obj = {}) {
  if (typeof obj === "function") {
    const callback = obj;
    callback(WrapperVue);
  }
  if (typeof obj === "object") {
    new Vue({
      el: "#app",
      ...obj,
    });
  }
}
